module.exports = __webpack_public_path__ + "static/deco-black5-691276993a33ccf87f973d868ae459fb.svg";